import React, { useEffect, useState } from "react";
import LoginHeader from "./LoginHeader";
import LoginTempSlider from "./LoginTempSlider";
import Template1 from "./images/temp-1-new.svg";
import Template2 from "./images/temp-2-new.png";
import Template3 from "./images/temp-3-new.png";
import LoginImg1 from "./images/LoginImg1.svg";
import LoginImg2 from "./images/LoginImg2.svg";
import styled from "styled-components";
import BgImg from "./images/new-b-bg.png";

export const LeftContent = styled.div`
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100%;
  background-image: url(${BgImg.src});
`;
export const ThreeDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  margin-top: 8px;
  position: absolute;
  left: 47%;
  bottom: 15%;

  @media screen and (max-width: 767px) {
    left: 45%;
    bottom: 5%;
  }
`;
export const Dots = styled.div`
  width: 11px;
  height: 11px;
  border-radius: 50px;
  background-color: #cbcbcb;
  cursor: pointer;
  border: 1px solid #ccc;
`;

// const getImage = (index) => {
//     switch (index) {
//         case 0:
//             return Template1;

//         case 1:
//             return Template2;

//         case 2:
//             return Template3;
//     }
// }
const getImage = (index) => {
  switch (index) {
    case 0:
      return LoginImg1;

    case 1:
      return LoginImg2;

    // case 2:
    //     return Template3;
  }
};

const contentSelector = (index) => {
  let obj = {};
  switch (index) {
    case 0:
      obj = {
        heading: "Business Research Platform",
        description:
          "Gift your business a competitive advantage with Ideapoke's platform Empowering you to make quick, informed decisions with confidence!.",
      };
      break;

    case 1:
      obj = {
        heading: "Business Research Platform",
        description:
          "Gift your business a competitive advantage with Ideapoke's platform Empowering you to make quick, informed decisions with confidence!",
      };
      break;

    // case 2:
    //     obj = {
    //         heading: "Work Together with your colleagues",
    //         description: "Share information seamlessly, research & build strategies together with your team."
    //     }
    //     break;
  }

  return obj;
};

const CarouselSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const updateSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      let nextSlide = currentSlide + 1;
      if (nextSlide > 1) {
        nextSlide = 0;
      }

      updateSlide(nextSlide);
    }, 4000000);

    return () => clearInterval(interval);
  });
  return (
    <LeftContent>
      {currentSlide == 0 && (
        <LoginTempSlider
          image1={true}
          Temp={getImage(0)}
          title={contentSelector(0).heading}
          desc={contentSelector(0).description}
        ></LoginTempSlider>
      )}

      {currentSlide == 1 && (
        <LoginTempSlider
          Temp={getImage(1)}
          title={contentSelector(1).heading}
          desc={contentSelector(1).description}
        ></LoginTempSlider>
      )}

      {/* {currentSlide == 2 && <LoginTempSlider
                Temp={getImage(2)}
                title={contentSelector(2).heading}
                desc={contentSelector(2).description}
            ></LoginTempSlider>} */}

      <ThreeDots>
        <Dots
          onClick={() => {
            updateSlide(0);
          }}
          style={currentSlide == 0 ? { backgroundColor: "#FF7624" } : {}}
        />
        <Dots
          onClick={() => {
            updateSlide(1);
          }}
          style={currentSlide == 1 ? { backgroundColor: "#FF7624" } : {}}
        />
        {/* <Dots
                    onClick={() => { updateSlide(2) }}
                    style={currentSlide == 2 ? { backgroundColor: "#FF7624" } : {}}
                /> */}
      </ThreeDots>
    </LeftContent>
  );
};

export default CarouselSlider;
